import React, { Fragment, memo, useState } from "react";

import { Switch } from './Switch';

export const SwitchList = memo((props) => {
  const { cm, items, usingItems } = props;

  return (
    <>
      <table className="table table-bordered table-hover table-condensed">
          <thead>
            <tr>
              <th style={{ width: 90 + 'px' }}>code</th>
              <th><i className="fas fa-tag" /> ラベル名/備考(ja)</th>
              <th><i className="fas fa-tag" /> ラベル名/備考(en)</th>
              <th><i className="fas fa-pencil-alt" /> 操作</th>
            </tr>
        </thead>
        <tbody>
          {items.map(item =>
            <Switch key={item.id} cm={cm} item={item} usingItems={usingItems} />
          )}
        </tbody>
      </table>
    </>
  );
});
